import { Component } from '@angular/core';
import { Platform, ModalController } from '@ionic/angular';
import { UserService } from '../services/user.service';
import { StylistService } from '../services';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Router } from '@angular/router';
import { Utilities } from '../utilities/utilities';

declare let window: any;
// declare var posthog: any;
@Component({
  selector: 'app-help',
  templateUrl: './help.page.html',
  styleUrls: ['./help.page.scss'],
})
export class HelpPage {
  constructor(
    //private navController: NavController,
    private userService: UserService,
    private stylistService: StylistService,
    private platform: Platform,
    //private navParams: NavParams,
    //private viewController: ViewController,
    private modalController: ModalController,
    private router: Router,
    private inAppBrowser: InAppBrowser
  ) {
  }

  public ionViewWillEnter() {
  }

  public onDismiss() {
    this.modalController.dismiss();
  }

  public redirectToHelpCenterLink() {
    const url = `https://support.salonmonster.com`;
    //const url = `https://salonmonster.crisp.help/en-ca/`;
    if (Utilities.isCapacitorNative() || this.platform.is('hybrid') || this.platform.is('cordova')) {
      //this.inAppBrowser.create(url, '_system');
    } else {
      const win = window.open(url, '_blank');
      win.focus();
    }
  }

  public showChat() {
    if (window && window.Beacon) {
      // Beacon 2.0 API - open the beacon
      window.Beacon('open');
    }
  }

}
